import React from 'react';
import { ProviderFilters } from '../../../app/models/Provider';

type Props = {
    filter: ProviderFilters;
    setFilter: (filter: ProviderFilters) => void;
};

const ProviderFilter = ({ filter, setFilter }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    const handlerSelectFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="society_rut">
                        Rut Sociedad
                    </label>
                    <input
                        type="text"
                        id="society_rut"
                        name="society_rut"
                        className="form-control form-control-sm"
                        value={filter.society_rut}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="society_name">
                        Sociedad
                    </label>
                    <input
                        type="text"
                        id="society_name"
                        name="society_name"
                        className="form-control form-control-sm"
                        value={filter.society_name}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="provider_rut">
                        Rut Proveedor
                    </label>
                    <input
                        type="text"
                        id="provider_rut"
                        name="provider_rut"
                        className="form-control form-control-sm"
                        value={filter.provider_rut}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="provider_name">
                        Nombre Proveedor
                    </label>
                    <input
                        type="text"
                        id="provider_name"
                        name="provider_name"
                        className="form-control form-control-sm"
                        value={filter.provider_name}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ProviderFilter;
